// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import TerceraMultiComboBoxTemplate from '@front/templates/TerceraMultiComboBoxTemplate.html';
import { Control } from './Control';
import { multiComboBoxPopupMenuHandler } from '@shared/utils/AppHandlers';
export class TerceraMultiComboBox extends Control {
    constructor() {
        super(...arguments);
        this.scrollIsShown = false;
        this.c = false;
    }
    getType() {
        return 'TerceraMultiComboBox';
    }
    oninit() {
        super.oninit();
        this.on('showPopup', this.showPopup);
        this.popupCallBack = this.popupCallBack.bind(this);
        this.observe('items', this.onItemsChanged);
    }
    onItemsChanged() {
        this.fire(MultiComboBoxEvents.ValueChange);
    }
    lostFocus() {
        super.lostFocus();
        void this.set('isPopupShown', false);
        this.getPopup().Hide();
    }
    setBooleans(boolArr) {
        let i = -1;
        void this.set('items', this.get('items').map((element) => {
            element.checked = boolArr[i++];
            return element;
        }));
    }
    showPopup() {
        const items = this.get('items');
        if (!this.get('enabled') || (items === null || items === void 0 ? void 0 : items.length) === 0) {
            return;
        }
        if (this.get('isPopupShown')) {
            void this.set('isPopupShown', false);
            this.getPopup().Hide();
            return;
        }
        const loc = ControlsUtils.getAbsoluteLocation(this);
        void this.set('isPopupShown', true);
        this.getPopup().Show(items, loc.X, loc.Y + 32 + 1, // 32 is the height of the control, 1 just for space
        this.find('*').offsetWidth, this.popupCallBack, this.get('hideAll'), this.get('useLastItem'));
    }
    popupCallBack(popupItems) {
        void this.set('isPopupShown', false);
        const popupItemsByText = {};
        if (isValidArray(popupItems)) {
            // converting array to object for instant item search
            popupItems.forEach((pI) => {
                if (isValidString(pI.text)) {
                    popupItemsByText[pI.text] = pI;
                }
            });
        }
        const items = this.get('items');
        for (let i = 0; i < items.length; i++) {
            const popupItem = popupItemsByText[items[i].text];
            if (popupItem != null) {
                // popupItem is user's selection, so we should use its value
                items[i].checked = popupItem.checked;
            }
        }
        void this.set('items', items); // this.update('items');
    }
    getPopup() {
        return multiComboBoxPopupMenuHandler;
    }
    isEmpty() {
        const items = this.get('items');
        return !isValidArray(items);
    }
    isAllItemsChecked() {
        if (this.isEmpty()) {
            return true;
        }
        const items = this.get('items');
        for (let i = 0; i < items.length; i++) {
            if (!items[i].checked) {
                return false;
            }
        }
        return true;
    }
    getItemsMap() {
        const map = new Map();
        if (this.isEmpty()) {
            return map;
        }
        const items = this.get('items');
        for (let i = 0; i < items.length; i++) {
            map.set(items[i].value, items[i].checked);
        }
        return map;
    }
    getSelectedItems() {
        const selectedValues = [];
        if (this.isEmpty()) {
            return selectedValues;
        }
        const items = this.get('items');
        for (let i = 0; i < items.length; i++) {
            if (items[i].checked) {
                selectedValues.push(items[i].value);
            }
        }
        return selectedValues;
    }
}
// Events
export var MultiComboBoxEvents;
(function (MultiComboBoxEvents) {
    MultiComboBoxEvents["ValueChange"] = "ValueChange";
})(MultiComboBoxEvents || (MultiComboBoxEvents = {}));
Control.extendWith(TerceraMultiComboBox, {
    data: function () {
        return {
            items: null,
            allItemsSelectedText: '',
            noItemsSelectedText: '',
            noItemsText: '',
            fewItemsSelectedPostfixText: '',
            hideAll: false,
            useLastItem: false,
            isPopupShown: false
        };
    },
    computed: {
        selectionText: {
            get: function () {
                const items = this.get('items');
                if (!isValidArray(items)) {
                    return this.get('noItemsText');
                }
                let lastCheckedIdx = -1;
                let checkedCount = 0;
                const len = items.length;
                for (let i = 0; i < len; i++) {
                    if (!items[i].checked)
                        continue;
                    lastCheckedIdx = i;
                    checkedCount++;
                }
                if (checkedCount === len) {
                    return this.get('allItemsSelectedText');
                }
                else if (checkedCount === 0) {
                    return this.get('noItemsSelectedText');
                }
                else if (checkedCount === 1) {
                    return items[lastCheckedIdx].text;
                }
                else {
                    return checkedCount + '/' + len + ' ' + this.get('fewItemsSelectedPostfixText');
                }
            },
            set: function () { }
        }
    },
    template: TerceraMultiComboBoxTemplate
});
